import { Clock, MapPin, Volume2, Users, Package, CalendarDays, Plus } from "lucide-react";
import { badgeZaPodrucje, ikonaZaPodrucje } from "@/lib/constants";

export default function ActivityCard({ activity: a, onOpen, onAdd }) {
  const Icon = ikonaZaPodrucje(a.podrucje);
  return (
    <article
      data-testid={`activity-card-${a.id}`}
      className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-transform duration-200 flex flex-col h-full overflow-hidden"
    >
      <div
        className="p-5 flex-1 cursor-pointer"
        onClick={onOpen}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onOpen(); } }}
        data-testid={`activity-open-${a.id}`}
      >
        <div className="flex flex-wrap gap-1.5 mb-3">
          <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold uppercase tracking-[0.05em] ${badgeZaPodrucje(a.podrucje)}`}>
            <Icon className="h-3 w-3" /> {a.podrucje}
          </span>
          {a.sezona !== "Cijela godina" && (
            <span className="inline-flex items-center gap-1 rounded-full bg-orange-100 px-2.5 py-1 text-xs font-bold uppercase tracking-[0.05em] text-orange-700">
              <CalendarDays className="h-3 w-3" /> {a.sezona}
            </span>
          )}
          {a.materijali.length === 0 && (
            <span className="rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-bold uppercase tracking-[0.05em] text-emerald-700">
              Bez materijala
            </span>
          )}
        </div>
        <h3 className="font-display text-lg font-bold text-slate-900 leading-tight">{a.naziv}</h3>
        <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-2">{a.opis}</p>
        <div className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2 text-sm font-medium text-slate-500">
          <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-slate-400" /> {a.trajanje} min</span>
          <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4 text-slate-400" /> {a.mjesto}</span>
          <span className="flex items-center gap-1.5"><Volume2 className="h-4 w-4 text-slate-400" /> {a.razina_buke}</span>
          <span className="flex items-center gap-1.5"><Users className="h-4 w-4 text-slate-400" /> {a.razredi.map((r) => `${r}.`).join(" ")}</span>
        </div>
      </div>
      <div className="border-t border-slate-100 px-5 py-3 flex items-center justify-between">
        <span className="flex items-center gap-1.5 text-xs font-medium text-slate-400">
          <Package className="h-3.5 w-3.5" />
          {a.materijali.length === 0 ? "ništa ne treba" : `${a.materijali.length} ${a.materijali.length === 1 ? "materijal" : "materijala"}`}
        </span>
        <button
          data-testid={`add-to-plan-${a.id}`}
          onClick={onAdd}
          className="inline-flex items-center gap-1.5 rounded-full bg-indigo-600 px-4 py-2 text-xs font-bold text-white hover:bg-indigo-700 hover:-translate-y-0.5 transition-transform duration-150"
        >
          <Plus className="h-3.5 w-3.5" /> Dodaj u plan
        </button>
      </div>
    </article>
  );
}
